import camelCase from 'lodash/camelCase';

const field = (key, label, extras = {}) => ({
  key,
  label,
  type: 'text',
  ...extras,
});

const section = (key, label) => ({
  key,
  label,
  type: 'section',
});

export const INSPECTOR_IDS = {
  DEFAULT: 'DefaultInspector',
  TWO_WINDING_TRANSFORMER: 'TwoWindingTransformerInspector',
  THREE_WINDING_TRANSFORMER: 'ThreeWindingTransformerInspector',
  POWER_SUPPLIER: 'PowerSupplierInspector',
  GENERATOR: 'GeneratorInspector',
  PHOTOVOLTAIC_GENERATOR: 'PhotovoltaicGeneratorInspector',
  INDUCTION_MOTOR: 'InductionMotorInspector',
  SYNCHRONOUS_MOTOR: 'SynchronousMotorInspector',
  SOFT_STARTER: 'SoftStarterInspector',
  UPS: 'UpsInspector',
  VFD: 'VfdInspector',
  THERMOMAGNETIC_SWITCH: 'ThermomagneticSwitchInspector',
  OVERLOAD_RELAY: 'OverloadRelayInspector',
  PROTECTION_RELAY: 'ProtectionRelayInspector',
  RESTAURATEUR: 'RestaurateurInspector',
  LOW_VOLTAGE_BREAKER: 'LowVoltageBreakerInspector',
  POWER_BREAKER: 'PowerBreakerInspector',
  DISTRIBUTION_BOARD: 'DistributionBoardInspector',
  CABLE: 'CableInspector',
  FIXED_CAPACITOR_BANK: 'FixedCapacitorBankInspector',
  AUTOMATIC_CAPACITOR_BANK: 'AutomaticCapacitorBankInspector',
  MEASUREMENT: 'MeasurementInspector',
  BUS: 'BusInspector',
  LOAD_CENTER: 'LoadCenterInspector',
  FUSES: 'FusesInspector',
  AERIAL_LINE: 'AerialLineInspector',
  TEXT_BOX: 'TextBoxInspector',
  BOX: 'BoxInspector',
};

export const inspectorDefinitions = {
  [INSPECTOR_IDS.DEFAULT]: { fields: [] },
  [INSPECTOR_IDS.TWO_WINDING_TRANSFORMER]: {
    fields: [
      field('brand', 'Marca'),
      field('model', 'Modelo'),
      field('type', 'Tipo'),
      field('ratedPower', 'Potencia nominal'),
      field('coolingType', 'Tipo de enfriamiento'),
      field('impedance', 'Impedancia'),
      field('neutralImpedance', 'Impedancia de Neutro (ZN)'),
      field('taps', 'Taps'),
      field('primaryInfo', 'Voltaje Primario'),
      field('secondaryInfo', 'Voltaje Secundario'),
    ],
  },
  [INSPECTOR_IDS.THREE_WINDING_TRANSFORMER]: {
    fields: [
      field('brand', 'Marca'),
      field('model', 'Modelo'),
      field('type', 'Tipo'),
      field('ratedPower', 'Potencia nominal'),
      field('coolingType', 'Tipo de enfriamiento'),
      field('impedance', 'Impedancia'),
      field('neutralImpedance', 'Impedancia de Neutro (ZN)'),
      field('taps', 'Taps'),
      field('primaryInfo', 'Voltaje Primario'),
      field('secondaryInfo', 'Voltaje Secundario'),
      field('tertiaryInfo', 'Voltaje Terciario'),
    ],
  },
  [INSPECTOR_IDS.POWER_SUPPLIER]: {
    fields: [
      field('nombre', 'Nombre'),
      field('ratedVoltage', 'Voltaje nominal'),
      field('threePhaseIcc', 'Icc trifásica'),
      field('lineToGroundIcc', 'Icc de línea a tierra'),
      field('threePhaseImpedance', 'X/R o Z trifásica'),
      field('lineToGroundImpedance', 'X/R o Z de línea a tierra'),
    ],
  },
  [INSPECTOR_IDS.GENERATOR]: {
    fields: [
      field('brand', 'Marca'),
      field('model', 'Modelo'),
      field('ratedPower', 'Potencia nominal'),
      field('ratedVoltage', 'Voltaje nominal'),
      field('ratedCurrent', 'Corriente nominal'),
      field('powerFactor', 'Factor de potencia'),
      field('efficiency', 'Eficiencia'),
      field('rpm', 'RPMs'),
    ],
  },
  [INSPECTOR_IDS.PHOTOVOLTAIC_GENERATOR]: {
    fields: [
      field('brand', 'Marca'),
      field('model', 'Modelo'),
      field('ratedPower', 'Potencia nominal'),
      field('ratedVoltage', 'Voltaje nominal'),
      field('ratedCurrent', 'Corriente nominal'),
      field('powerFactor', 'Factor de potencia'),
    ],
  },
  [INSPECTOR_IDS.INDUCTION_MOTOR]: {
    fields: [
      field('brand', 'Marca'),
      field('model', 'Modelo'),
      field('ratedPower', 'Potencia nominal'),
      field('ratedVoltage', 'Voltaje nominal'),
      field('ratedCurrent', 'Corriente nominal'),
      field('powerFactor', 'Factor de potencia'),
      field('efficiency', 'Eficiencia'),
      field('rpm', 'RPMs'),
    ],
  },
  [INSPECTOR_IDS.SYNCHRONOUS_MOTOR]: {
    fields: [
      field('brand', 'Marca'),
      field('model', 'Modelo'),
      field('ratedPower', 'Potencia nominal'),
      field('ratedVoltage', 'Voltaje nominal'),
      field('ratedCurrent', 'Corriente nominal'),
      field('efficiency', 'Eficiencia'),
      field('rpm', 'RPMs'),
    ],
  },
  [INSPECTOR_IDS.SOFT_STARTER]: {
    fields: [
      field('brand', 'Marca'),
      field('model', 'Modelo'),
      field('ratedPower', 'Potencia nominal'),
      field('ratedVoltage', 'Voltaje nominal'),
      field('ratedCurrent', 'Corriente nominal'),
      field('settings', 'Ajustes'),
    ],
  },
  [INSPECTOR_IDS.UPS]: {
    fields: [
      field('brand', 'Marca'),
      field('model', 'Modelo'),
      field('power', 'Potencia'),
      section('mainProtectionHeader', 'Protección principal'),
      field('protectionBrand', 'Marca (protección)'),
      field('protectionModel', 'Modelo (protección)'),
      field('protectionRatedCurrent', 'Corriente nominal (protección)'),
      field('protectionBreakingCapacity', 'Capacidad interruptiva (protección)'),
    ],
  },
  [INSPECTOR_IDS.VFD]: {
    fields: [
      field('brand', 'Marca'),
      field('model', 'Modelo'),
      field('power', 'Potencia'),
      field('ratedVoltage', 'Voltaje nominal'),
      field('ratedCurrent', 'Corriente nominal'),
      field('settings', 'Ajustes'),
    ],
  },
  [INSPECTOR_IDS.THERMOMAGNETIC_SWITCH]: {
    fields: [
      field('brand', 'Marca'),
      field('model', 'Modelo'),
      field('phaseCount', 'Número de fases'),
      field('ratedCurrent', 'Corriente nominal'),
      field('breakingCapacity', 'Capacidad interruptiva'),
      field('instantAdjustment', 'Ajustes instantáneo'),
    ],
  },
  [INSPECTOR_IDS.OVERLOAD_RELAY]: {
    fields: [
      field('brand', 'Marca'),
      field('model', 'Modelo'),
      field('ratedCurrent', 'Corriente nominal'),
      field('classRating', 'Clase'),
      field('plugSetting', 'Plug'),
      field('breakingCapacity', 'Capacidad interruptiva'),
      field('tripUnit', 'Unidad de disparo'),
      field('phaseAdjustments', 'Ajustes de fase'),
      field('groundAdjustments', 'Ajustes de tierra'),
      field('adjustment', 'Ajuste'),
    ],
  },
  [INSPECTOR_IDS.LOW_VOLTAGE_BREAKER]: {
    fields: [
      field('nombre', 'Nombre'),
      field('brand', 'Marca'),
      field('model', 'Modelo'),
      field('ratedCurrent', 'Corriente nominal (In)'),
      field('breakingCapacity', 'Capacidad interruptiva (CI)'),
      field('plugSetting', 'Plug'),
      field('tripUnit', 'Unidad de disparo (UD)'),
      section('settingsHeader', 'Ajustes'),
      field('ltpu', 'Ajuste de tiempo largo (LTPU)'),
      field('ltd', 'Retardo de tiempo largo (LTD)'),
      field('stpu', 'Ajuste de tiempo corto (STPU)'),
      field('std', 'Retardo de tiempo corto (STD)'),
      field('instantaneous', 'Instantáneo (INST)'),
      field('gfpu', 'Ajuste de tiempo largo de tierra (GFPU)'),
      field('gfd', 'Retardo tierra (GFD)'),
    ],
  },
  [INSPECTOR_IDS.PROTECTION_RELAY]: {
    fields: [
      field('nombre', 'Nombre'),
      field('brand', 'Marca'),
      field('model', 'Modelo'),
      field('ratedVoltage', 'Voltaje nominal'),
      field('ratedCurrent', 'Corriente nominal'),
      field('interruptingCapacity', 'Capacidad interruptiva'),
      field('currentTransformerRatio', 'Relación de transformadores de corriente (ej. 50/5, 250/5)'),
      section('phaseProtection', 'Protección 50/51 Fase'),
      field('phaseLongTimePickup', 'Pickup de tiempo largo'),
      field('phaseCurveType', 'Tipo de curva'),
      field('phaseTimeDelay', 'Retardo de tiempo'),
      field('phaseShortTimePickup', 'Pickup de tiempo corto'),
      field('phaseDefiniteTime', 'Tiempo definido'),
      field('phaseInstantaneous', 'Instantáneo'),
      section('groundProtection', 'Protección 50/51 Tierra'),
      field('groundLongTimePickup', 'Pickup de tiempo largo'),
      field('groundCurveType', 'Tipo de curva'),
      field('groundTimeDelay', 'Retardo de tiempo'),
      field('groundShortTimePickup', 'Pickup de tiempo corto'),
      field('groundDefiniteTime', 'Tiempo definido'),
      field('groundInstantaneous', 'Instantáneo'),
      section('otherProtectionsSection', 'Otras protecciones'),
      field('otherProtections', 'Otras protecciones'),
    ],
  },
  [INSPECTOR_IDS.POWER_BREAKER]: {
    fields: [
      field('brand', 'Marca'),
      field('model', 'Modelo'),
      field('ratedVoltage', 'Voltaje nominal'),
      field('ratedCurrent', 'Corriente nominal'),
      field('interruptingCapacity', 'Capacidad interruptiva'),
    ],
  },
  [INSPECTOR_IDS.RESTAURATEUR]: {
    fields: [
      field('brand', 'Marca'),
      field('model', 'Modelo'),
      field('ratedVoltage', 'Voltaje nominal'),
      field('ratedCurrent', 'Corriente nominal'),
      field('interruptingCapacity', 'Capacidad interruptiva'),
      field('currentTransformerRatio', 'Relación de transformadores de corriente'),
    ],
  },
  [INSPECTOR_IDS.DISTRIBUTION_BOARD]: {
    fields: [
      field('brand', 'Marca'),
      field('model', 'Modelo'),
      field('sectionCount', 'Número de secciones'),
      field('ratedVoltage', 'Voltaje nominal'),
      field('ratedCurrent', 'Corriente nominal'),
      field('shortCircuitCapacity', 'Capacidad de cortocircuito'),
      field('compartmentCount', 'Número de compartimientos'),
      section('dimensionsHeader', 'Dimensiones'),
      field('height', 'Alto'),
      field('width', 'Ancho'),
      field('depth', 'Profundo'),
    ],
  },
  [INSPECTOR_IDS.CABLE]: {
    fields: [
      field('nombre', 'Nombre'),
      field('phaseGauge', 'Calibre fases'),
      field('conductorsPerPhase', 'No. de conductores por fase'),
      field('length', 'Longitud'),
      field('ampacidad', 'Ampacidad'),
      field('neutralGauge', 'Calibre neutro'),
      field('conductorsPerNeutral', 'No. de conductores por neutro'),
      field('groundGauge', 'Calibre tierra'),
      field('conductorsPerGround', 'No. de conductores por tierra'),
      field('conduitType', 'Canalización'),
      field('brand', 'Marca'),
      field('insulation', 'Aislamiento'),
    ],
  },
  [INSPECTOR_IDS.FIXED_CAPACITOR_BANK]: {
    fields: [
      field('brand', 'Marca'),
      field('model', 'Modelo'),
      field('nominalKvar', 'kVar nominales'),
      section('mainProtectionHeader', 'Protección principal'),
      field('protectionBrand', 'Marca (protección)'),
      field('protectionModel', 'Modelo (protección)'),
      field('protectionRatedCurrent', 'Corriente nominal (protección)'),
      field('protectionBreakingCapacity', 'Capacidad interruptiva (protección)'),
      field('adjustments', 'Ajustes'),
      field('filter', 'Filtro'),
    ],
  },
  [INSPECTOR_IDS.AUTOMATIC_CAPACITOR_BANK]: {
    fields: [
      field('brand', 'Marca'),
      field('model', 'Modelo'),
      field('nominalKvar', 'kVar nominales'),
      field('stepsCount', 'Número de pasos'),
      field('stepKvarDetails', 'kVar de cada paso'),
      section('mainProtectionHeader', 'Protección principal'),
      field('protectionBrand', 'Marca (protección)'),
      field('protectionModel', 'Modelo (protección)'),
      field('protectionRatedCurrent', 'Corriente nominal (protección)'),
      field('protectionBreakingCapacity', 'Capacidad interruptiva (protección)'),
      field('adjustments', 'Ajustes'),
      field('filter', 'Filtro'),
    ],
  },
  [INSPECTOR_IDS.MEASUREMENT]: {
    fields: [
      field('nombre', 'Nombre'),
      field('brand', 'Marca'),
      field('model', 'Modelo'),
    ],
  },
  [INSPECTOR_IDS.FUSES]: {
    fields: [
      field('brand', 'Marca'),
      field('model', 'Modelo'),
      field('ratedVoltage', 'Voltaje nominal'),
      field('phaseCount', 'Número de fases'),
      field('ratedCurrent', 'Corriente nominal'),
      field('breakingCapacity', 'Capacidad interruptiva'),
    ],
  },
  [INSPECTOR_IDS.AERIAL_LINE]: {
    fields: [
      field('nombre', 'Nombre'),
      field('ratedVoltage', 'Voltaje nominal'),
      field('height', 'Altura'),
      field('lineSeparation', 'Separación entre líneas'),
      field('cable', 'Cable'),
      field('length', 'Longitud'),
      field('ampacity', 'Ampacidad'),
    ],
  },
  [INSPECTOR_IDS.BUS]: {
    fields: [
      field('nombre', 'Nombre'),
      field('ratedVoltage', 'Voltaje nominal'),
      field('brand', 'Marca'),
      field('model', 'Modelo'),
      field('ratedCurrent', 'Corriente nominal'),
      field('shortCircuitCurrent', 'Corriente de corto circuito'),
    ],
  },
  [INSPECTOR_IDS.LOAD_CENTER]: {
    customRenderer: 'distributionBoard',
    fields: [],
  },
  [INSPECTOR_IDS.TEXT_BOX]: {
    fields: [
      field('textContent', 'Texto', { type: 'textarea' }),
      field('backgroundColor', 'Color de fondo', { type: 'color' }),
      field('textColor', 'Color del texto', { type: 'color' }),
    ],
  },
  [INSPECTOR_IDS.BOX]: {
    fields: [
      field('strokeWidth', 'Ancho de borde (px)', { renderMode: 'custom' }),
      field('width', 'Ancho (px)', { renderMode: 'custom' }),
      field('height', 'Alto (px)', { renderMode: 'custom' }),
      field('borderStyle', 'Estilo de borde', { renderMode: 'custom' }),
    ],
    customRenderer: 'box',
  },
};

const svgMap = (pairs) => pairs.reduce((acc, [path, inspector]) => {
  acc[path] = inspector;
  return acc;
}, {});

export const symbolInspectorRegistry = {
  TwoWindingTransformer: {
    defaultInspector: INSPECTOR_IDS.TWO_WINDING_TRANSFORMER,
  },
  ThreeWindingTransformer: {
    defaultInspector: INSPECTOR_IDS.THREE_WINDING_TRANSFORMER,
  },
  ElectricEnergySupplier: {
    defaultInspector: INSPECTOR_IDS.POWER_SUPPLIER,
    aliasOverrides: {
      'generador-a': INSPECTOR_IDS.GENERATOR,
      'banco-baterias': INSPECTOR_IDS.GENERATOR,
      'generador-solar': INSPECTOR_IDS.PHOTOVOLTAIC_GENERATOR,
      'generador-eolico': INSPECTOR_IDS.PHOTOVOLTAIC_GENERATOR,
    },
    svgOverrides: svgMap([
      ['/symbol-assets/GeneradorSimbolo1.svg', INSPECTOR_IDS.GENERATOR],
      ['/symbol-assets/BancoDeBaterias.svg', INSPECTOR_IDS.GENERATOR],
      ['/symbol-assets/GeneradorSolar.svg', INSPECTOR_IDS.PHOTOVOLTAIC_GENERATOR],
      ['/symbol-assets/GeneradorEolico.svg', INSPECTOR_IDS.PHOTOVOLTAIC_GENERATOR],
    ]),
  },
  Generator: {
    defaultInspector: INSPECTOR_IDS.INDUCTION_MOTOR,
    aliasOverrides: {
      'motor-sincrono': INSPECTOR_IDS.SYNCHRONOUS_MOTOR,
      'cargas-no-motor': INSPECTOR_IDS.SYNCHRONOUS_MOTOR,
      'cargas-no-motor-B': INSPECTOR_IDS.SYNCHRONOUS_MOTOR,
      'contactos-trifasicos': INSPECTOR_IDS.SYNCHRONOUS_MOTOR,
    },
    svgOverrides: svgMap([
      ['/symbol-assets/MotorSincrono.svg', INSPECTOR_IDS.SYNCHRONOUS_MOTOR],
      ['/symbol-assets/CargaNoMotor.svg', INSPECTOR_IDS.SYNCHRONOUS_MOTOR],
      ['/symbol-assets/CargaNoMotorB.svg', INSPECTOR_IDS.SYNCHRONOUS_MOTOR],
      ['/symbol-assets/ReceptaculoTrifasico.svg', INSPECTOR_IDS.SYNCHRONOUS_MOTOR],
    ]),
  },
  ElectronicRelay: {
    defaultInspector: INSPECTOR_IDS.VFD,
    aliasOverrides: {
      ups: INSPECTOR_IDS.UPS,
      'variador-de-frecuencia': INSPECTOR_IDS.VFD,
      rectificador: INSPECTOR_IDS.VFD,
      inversor: INSPECTOR_IDS.VFD,
      'arrancador-suave': INSPECTOR_IDS.SOFT_STARTER,
      'iec-relevador-de-sobrecarga': INSPECTOR_IDS.PROTECTION_RELAY,
    },
  },
  ElectromagneticSwitch: {
    defaultInspector: INSPECTOR_IDS.OVERLOAD_RELAY,
    aliasOverrides: {
      'ansi-interruptor-termomagnético-a': INSPECTOR_IDS.THERMOMAGNETIC_SWITCH,
      'ansi-interruptor-termomagnético-a-base': INSPECTOR_IDS.THERMOMAGNETIC_SWITCH,
      'ansi-interruptor-Unidad-Disparo-Electronica': INSPECTOR_IDS.LOW_VOLTAGE_BREAKER,
      'ansi-relevador-de-sobrecarga': INSPECTOR_IDS.PROTECTION_RELAY,
      'relevador-de-carga': INSPECTOR_IDS.OVERLOAD_RELAY,
      restaurador: INSPECTOR_IDS.RESTAURATEUR,
      switch: INSPECTOR_IDS.OVERLOAD_RELAY,
    },
    svgOverrides: svgMap([
      ['/symbol-assets/InterruptorTermomagneticoSimbolo1.svg', INSPECTOR_IDS.THERMOMAGNETIC_SWITCH],
      ['/symbol-assets/IECInterruptorTermomagneticoSimbolo1.svg', INSPECTOR_IDS.THERMOMAGNETIC_SWITCH],
      ['/symbol-assets/RelevadorSimbolo1.svg', INSPECTOR_IDS.PROTECTION_RELAY],
      ['/symbol-assets/RelevadorDeCarga.svg', INSPECTOR_IDS.OVERLOAD_RELAY],
      ['/symbol-assets/Restaurador.svg', INSPECTOR_IDS.RESTAURATEUR],
      ['/symbol-assets/IECRelevadorDeSobrecarga.svg', INSPECTOR_IDS.RESTAURATEUR],
      ['/symbol-assets/Switch.svg', INSPECTOR_IDS.OVERLOAD_RELAY],
      ['/assets/editor-symbols/InterruptorTermomagneticoSimbolo1.svg', INSPECTOR_IDS.THERMOMAGNETIC_SWITCH],
      ['/assets/editor-symbols/IECInterruptorTermomagneticoSimbolo1.svg', INSPECTOR_IDS.THERMOMAGNETIC_SWITCH],
      ['/assets/editor-symbols/InterruptorTermomagnetico.svg', INSPECTOR_IDS.THERMOMAGNETIC_SWITCH],
      ['/assets/editor-symbols/InterruptortermomagneticoSimbolo2.svg', INSPECTOR_IDS.THERMOMAGNETIC_SWITCH],
      ['/assets/editor-symbols/IECInterruptorTermomagneticoSimbolo2.svg', INSPECTOR_IDS.THERMOMAGNETIC_SWITCH],
      ['/assets/editor-symbols/RelevadorSimbolo1.svg', INSPECTOR_IDS.PROTECTION_RELAY],
      ['/assets/editor-symbols/RelevadorDeCarga.svg', INSPECTOR_IDS.OVERLOAD_RELAY],
      ['/assets/editor-symbols/Restaurador.svg', INSPECTOR_IDS.RESTAURATEUR],
      ['/assets/editor-symbols/IECRelevadorDeSobrecarga.svg', INSPECTOR_IDS.RESTAURATEUR],
      ['/assets/editor-symbols/Switch.svg', INSPECTOR_IDS.OVERLOAD_RELAY],
    ]),
  },
  Restaurateur: {
    defaultInspector: INSPECTOR_IDS.RESTAURATEUR,
  },
  Fuse: {
    defaultInspector: INSPECTOR_IDS.FUSES,
    svgOverrides: svgMap([
      ['/symbol-assets/ANSIFusibleSimbolo1.svg', INSPECTOR_IDS.FUSES],
      ['/symbol-assets/ANSIFusibleSimbolo2.svg', INSPECTOR_IDS.FUSES],
      ['/symbol-assets/ANSIFusibleSimbolo3.svg', INSPECTOR_IDS.FUSES],
      ['/assets/editor-symbols/ANSIFusibleSimbolo1.svg', INSPECTOR_IDS.FUSES],
      ['/assets/editor-symbols/ANSIFusibleSimbolo2.svg', INSPECTOR_IDS.FUSES],
      ['/assets/editor-symbols/ANSIFusibleSimbolo3.svg', INSPECTOR_IDS.FUSES],
      ['/symbol-assets/IECFusibleSimbolo1.svg', INSPECTOR_IDS.FUSES],
      ['/symbol-assets/IECFusibleSimbolo2.svg', INSPECTOR_IDS.FUSES],
      ['/assets/editor-symbols/IECFusibleSimbolo1.svg', INSPECTOR_IDS.FUSES],
      ['/assets/editor-symbols/IECFusibleSimbolo2.svg', INSPECTOR_IDS.FUSES],
    ]),
  },
  ElectronicSwitch: {
    defaultInspector: INSPECTOR_IDS.OVERLOAD_RELAY,
  },
  PowerSwitch: {
    defaultInspector: INSPECTOR_IDS.POWER_BREAKER,
  },
  OverloadRelay: {
    defaultInspector: INSPECTOR_IDS.FIXED_CAPACITOR_BANK,
    aliasOverrides: {
      'reactor-a-tierra': INSPECTOR_IDS.FIXED_CAPACITOR_BANK,
      'banco-de-capacitadores': INSPECTOR_IDS.FIXED_CAPACITOR_BANK,
      'filtro-de-armonicos-a': INSPECTOR_IDS.AUTOMATIC_CAPACITOR_BANK,
      'filtro-de-armonicos-b': INSPECTOR_IDS.AUTOMATIC_CAPACITOR_BANK,
    },
    svgOverrides: svgMap([
      ['/symbol-assets/ReactorATierra.svg', INSPECTOR_IDS.FIXED_CAPACITOR_BANK],
      ['/symbol-assets/BancoDeCapacitores.svg', INSPECTOR_IDS.FIXED_CAPACITOR_BANK],
      ['/symbol-assets/FiltroDeArmonicosSimbolo1.svg', INSPECTOR_IDS.AUTOMATIC_CAPACITOR_BANK],
      ['/symbol-assets/FiltroDeArmonicosSimbolo1B.svg', INSPECTOR_IDS.AUTOMATIC_CAPACITOR_BANK],
    ]),
  },
  Vfd: {
    defaultInspector: INSPECTOR_IDS.DISTRIBUTION_BOARD,
    aliasOverrides: {
      'línea aérea a': INSPECTOR_IDS.AERIAL_LINE,
      'línea aérea b': INSPECTOR_IDS.AERIAL_LINE,
    },
  },
  Cable: {
    defaultInspector: INSPECTOR_IDS.CABLE,
  },
  Bus: {
    defaultInspector: INSPECTOR_IDS.BUS,
  },
  BusMononodo: {
    defaultInspector: INSPECTOR_IDS.BUS,
  },
  DistributionBoard: {
    defaultInspector: INSPECTOR_IDS.LOAD_CENTER,
  },
  LightningContactChargingCenter: {
    defaultInspector: INSPECTOR_IDS.MEASUREMENT,
  },
  SoftStarter: {
    defaultInspector: INSPECTOR_IDS.SOFT_STARTER,
  },
  Ups: {
    defaultInspector: INSPECTOR_IDS.UPS,
  },
  PhotovoltaicGenerator: {
    defaultInspector: INSPECTOR_IDS.PHOTOVOLTAIC_GENERATOR,
  },
  TextBox: {
    defaultInspector: INSPECTOR_IDS.TEXT_BOX,
  },
  Box: {
    defaultInspector: INSPECTOR_IDS.BOX,
  },
};

const ensureAttributes = (definition) => {
  if (!definition || !Array.isArray(definition.fields)) return {};
  return definition.fields
    .filter((fieldDef) => fieldDef.type !== 'section')
    .reduce((acc, fieldDef) => {
      const key = fieldDef.key || camelCase(fieldDef.label || '');
      if (!key) return acc;
      acc[key] = {
        isVisible: true,
        value: null,
        label: fieldDef.label || key,
      };
      return acc;
    }, {});
};

const getSelectedVariantAlias = (variants) => {
  if (!Array.isArray(variants) || variants.length === 0) return null;
  const selected = variants.find((variant) => variant.selected);
  return selected ? selected.alias : variants[0]?.alias || null;
};

const normalize = (value) => (typeof value === 'string' ? value.trim().toLowerCase() : null);

export const getNodeLabelOverrideKey = (nodeData, resolvedInspectorId = null) => {
  if (!nodeData || !nodeData.symbolLabel) {
    return null;
  }
  const registryEntry = symbolInspectorRegistry[nodeData.symbolLabel] || {};
  const inspectorId = resolvedInspectorId || registryEntry.defaultInspector || INSPECTOR_IDS.DEFAULT;
  return `${inspectorId}::${nodeData.symbolLabel}`;
};

export const resolveInspectorForNode = (nodeData, labelOverrides = {}) => {
  if (!nodeData || !nodeData.symbolLabel) {
    return {
      inspectorId: INSPECTOR_IDS.DEFAULT,
      definition: inspectorDefinitions[INSPECTOR_IDS.DEFAULT],
      attributes: ensureAttributes(inspectorDefinitions[INSPECTOR_IDS.DEFAULT]),
    };
  }

  const registryEntry = symbolInspectorRegistry[nodeData.symbolLabel] || {};
  let inspectorId = registryEntry.defaultInspector || INSPECTOR_IDS.DEFAULT;

  const alias = nodeData.alias || getSelectedVariantAlias(nodeData.variants);
  if (alias && registryEntry.aliasOverrides) {
    const normalized = normalize(alias);
    inspectorId =
      registryEntry.aliasOverrides[alias] ||
      registryEntry.aliasOverrides[normalized] ||
      inspectorId;
  }

  const svgSrc = nodeData.svgSrc || (nodeData.variants && nodeData.variants[0]?.diagramSvgSrc);
  if (svgSrc && registryEntry.svgOverrides) {
    inspectorId = registryEntry.svgOverrides[svgSrc] || inspectorId;
  }

  const definition = inspectorDefinitions[inspectorId] || inspectorDefinitions[INSPECTOR_IDS.DEFAULT];
  const templateAttributes = ensureAttributes(definition);
  const labelOverrideKey = getNodeLabelOverrideKey(nodeData, inspectorId);
  const overridesForNode =
    labelOverrideKey && labelOverrides && typeof labelOverrides === 'object'
      ? (labelOverrides[labelOverrideKey] || {})
      : {};
  const existingAttributes = (nodeData && nodeData.attributes) || {};
  const resultAttributes = { ...templateAttributes };
  const configuredKeys = new Set(Object.keys(templateAttributes));
  const preserveKeys = new Set(['nombre']);

  Object.entries(existingAttributes).forEach(([key, attr]) => {
    if (!attr) return;
    if (configuredKeys.has(key)) {
      const template = templateAttributes[key] || {};
      const userModified = attr?.visibilityUserModified === true;
      const templateVisible = template.isVisible === undefined ? true : template.isVisible;
      const overrideLabel = overridesForNode[key];
      resultAttributes[key] = {
        ...template,
        ...attr,
        label: overrideLabel ?? attr.label ?? template.label ?? key,
        isVisible: userModified ? !!attr.isVisible : templateVisible,
        visibilityUserModified: userModified,
      };
      if (!Object.prototype.hasOwnProperty.call(resultAttributes[key], 'value')) {
        resultAttributes[key].value = null;
      }
      return;
    }
    if (preserveKeys.has(key) || attr.systemManaged || attr.systemDefined) {
      resultAttributes[key] = { ...attr };
    }
  });

  const existingNombre = existingAttributes.nombre || {};
  const nombreTemplate = templateAttributes.nombre || {};
  const currentNombre = resultAttributes.nombre || {};
  const resolvedNombre = {
    ...nombreTemplate,
    ...currentNombre,
    ...existingNombre,
  };
  if (resolvedNombre.value == null) {
    resolvedNombre.value = existingNombre.value ?? currentNombre.value ?? null;
  }
  const nombreUserModified =
    existingNombre.visibilityUserModified === true || currentNombre.visibilityUserModified === true;
  const nombreVisibleSource =
    existingNombre.isVisible !== undefined
      ? existingNombre.isVisible
      : currentNombre.isVisible !== undefined
      ? currentNombre.isVisible
      : nombreTemplate.isVisible;
  resolvedNombre.isVisible = nombreUserModified
    ? !!nombreVisibleSource
    : true;
  resolvedNombre.visibilityUserModified = nombreUserModified;
  resolvedNombre.label = overridesForNode.nombre || resolvedNombre.label || 'Nombre';
  resultAttributes.nombre = resolvedNombre;

  return {
    inspectorId,
    definition,
    attributes: resultAttributes,
  };
};

export const getInspectorDefinition = (inspectorId) =>
  inspectorDefinitions[inspectorId] || inspectorDefinitions[INSPECTOR_IDS.DEFAULT];
